// extracted by mini-css-extract-plugin
export default {"message-input":"InputField_message-input__DFyG8","message-send":"InputField_message-send__FFaiK"};